// extracted by mini-css-extract-plugin
module.exports = {"container":"spacer_container__3vD-t"};